import dataApi from '../'

export default {

  /**
   * Get units that the given user is allowed to see
   */
  getOverview (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/settings/overview-organization-settings',
      params: params
    })
  },

  /**
   * Get units based on a search value
   */
  getSearch (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/settings/search-organization-settings',
      params: params
    })
  },

  /**
   * Delete unit
   */
  deleteDeleteOrganizationSettings (params) {
    return dataApi.request({
      method: 'delete',
      url: 'ui/settings/delete-organization-settings',
      params: params
    })
  },

  /**
   * Get default settings
   */
  getDefaultSettings (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/settings/default-settings',
      params: params
    })
  },

  /**
   * Get settings by organisation and unit type
   */
  getSettingsByOrgAndUnittype (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/settings/settings-by-org-and-unittype',
      params: params
    })
  },

  /**
   * Post settings for unit
   */
  postOverrideSettingsForUnit (uuid, params) {
    return dataApi.request({
      method: 'post',
      url: 'ui/settings/override-settings-for-unit?uuid=' + uuid,
      body: params
    })
  },

  /**
   * Get settings by unit uuid
   */
  getSettingsByUnit (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/settings/unit-settings',
      params: params
    })
  },

  /**
   * Post settings for unit
   */
  postOverrideSettingsForOrganization (url, params) {
    return dataApi.request({
      method: 'post',
      url: 'ui/settings/override-settings-for-organization',
      params: url,
      body: params
    })
  },

  /**
   * Post settings for unit
   */
  postUpdateSettingsForOrganization (url, params) {
    return dataApi.request({
      method: 'post',
      url: 'ui/settings/update-settings-for-organization',
      params: url,
      body: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/softwaresettings.js